import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { Dialog } from 'primereact/dialog'
import { LuxButton, Color } from '@lux/wardrobe-lib'
import './DialogCloseVisit.scss'

const DialogCloseVisit = (props: {
    dialogVisible: boolean
    onHide: () => void
    onConfirm: () => void
}) => {
    const { dialogVisible, onHide, onConfirm } = props

    const componentClass = 'smart-modals-dialog-close-visit'

    const intl = useIntl()

    const renderFooter = () => {
        return (
            <div className={`${componentClass}-buttons`}>
                <LuxButton
                    onClick={onConfirm}
                    text={intl.formatMessage({
                        id: 'ph2.modals.new.activity.creation.cta.conclude',
                        defaultMessage: 'Conclude',
                    })}
                    color={Color.WARNING}
                />
            </div>
        )
    }

    return (
        <Dialog
            header={intl.formatMessage({
                id: 'modals.activity.visit.close',
                defaultMessage: 'Close this Visit',
            })}
            draggable={false}
            visible={dialogVisible}
            onHide={() => onHide()}
            footer={renderFooter()}
            style={{ width: '50vw' }}
            maskClassName={componentClass}
            breakpoints={{ '960px': '85vw' }}>
            <div>
                <div className={`${componentClass}-description text-bold`}>
                    {intl.formatMessage({
                        id: 'modals.activity.visit.close.description',
                        defaultMessage: 'By closing the visit, you will not be able to edit it.',
                    })}
                </div>
                <div className={`${componentClass}-description text`}>
                    {intl.formatMessage({
                        id: 'modals.activity.visit.close.content',
                        defaultMessage: 'Are you sure you want to close the visit?',
                    })}
                </div>
            </div>
        </Dialog>
    )
}

export default DialogCloseVisit
